module.exports = __webpack_public_path__ + "static/img/2019.4d68523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2019.jpg
// module id = 309
// module chunks = 0